module.exports = __webpack_public_path__ + "static/17-1-c62c0bbce670151d4208ced37e89c042.jpg";